import React from 'react';
import { LoaderFunctionArgs, Outlet, redirect } from 'react-router-dom';
import { ApiResponseError } from '../../api/ApiResponseError';
import { getCustomerVerificationStatus } from '../../api/tvs/customer/customerVerificationStatus';
import {
  DSA_DOCUMENT_CHECK_FAILED_PATH,
  DSA_VERIFICATION_BASE_PATH,
  DSA_VERIFICATION_ERROR_PATH,
} from '../../routePaths';
import {
  isResolvedVerificationRoute,
  resolveInReviewVerificationRoutePath,
  resolveVerificationRoutePath,
} from './verificationRouting';
import { routeWithSearch } from '../../utils/routeWithSearch';

export async function loader({ request }: LoaderFunctionArgs) {
  const url = new URL(request.url);
  const pathname = url.pathname;
  const search = url.search;

  if (isResolvedVerificationRoute(pathname)) {
    return null;
  }

  try {
    const verificationStatus = await getCustomerVerificationStatus();
    const routePath =
      pathname === DSA_DOCUMENT_CHECK_FAILED_PATH
        ? resolveInReviewVerificationRoutePath(verificationStatus)
        : resolveVerificationRoutePath(verificationStatus);

    if (routePath !== pathname && routePath !== DSA_VERIFICATION_BASE_PATH) {
      return redirect(routeWithSearch(routePath, search));
    }

    if (pathname === DSA_DOCUMENT_CHECK_FAILED_PATH && routePath !== DSA_DOCUMENT_CHECK_FAILED_PATH) {
      return redirect(routeWithSearch(routePath, search));
    }

    return verificationStatus;
  } catch (error) {
    if (error instanceof ApiResponseError) {
      return redirect(routeWithSearch(DSA_VERIFICATION_ERROR_PATH, search));
    }

    return redirect(routeWithSearch(DSA_VERIFICATION_ERROR_PATH, search));
  }
}

export const shouldRevalidate = () => false;

const VerificationLandingPage: React.FC = () => {
  return <Outlet />;
};

export default VerificationLandingPage;
